import React from 'react'
import IllustrationWrapper from '../../Illustrration/IllustrationWrapper'
import DataLostSvg from '../../Illustrration/components/DataLostSvg'

const NoAccess = () => {
  return (
    <IllustrationWrapper 
        illustration={<DataLostSvg />}
        title="Access Denied!"
        subtitle="Please select a different SAP code to enable and use this feature. "
    />
  )
}

export default NoAccess